import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { DialogService, GridContentWidget } from '@eforall/dashboard';
import { TabStripModule } from '@progress/kendo-angular-layout';
import { PersonExplorerService } from '../person-explorer.service';
import { getSetup } from "./grid/get-setup";

@Component({
	selector: 'person-entrepreneurship-part',
	standalone: true,
	imports: [
		TabStripModule,
		GridContentWidget
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './person-entrepreneurship.part.html'
})

export class PersonEntrepreneurshipPart {

	#util = inject(UtilityService);
	#dialog = inject(DialogService);
	personExplorer = inject(PersonExplorerService);
	public setup = getSetup(this.#util, this.#dialog);


	public entrepreneurship = computed(() => this.personExplorer.person.value()?.entrepreneurship ?? []);
}